import 'isomorphic-fetch'
import { createFetch, accept, header, init } from 'http-client'

const fetch = createFetch(
  accept('application/json'),
  header('x-csrf-token', window.segment.csrf), // TODO get token from redux
  header('content-type', 'application/json'),
  init('credentials', 'same-origin')
)

export default fetch



// WEBPACK FOOTER //
// ./lib/fetch.js